import { NavigationTabs } from './NavigationTabs.js';

export class MessengerPanel {
	constructor(state, options = {}) {
		this.state = state;
		this.options = {
			position: options.position || 'bottom-right',
			...options,
		};
		this.element = null;
		this.navigationTabs = null;
		this.currentViewComponent = null;
		this.viewRegistry = {};
		this._unsubscribe = null;
	}

	registerView(name, ViewClass) {
		this.viewRegistry[name] = ViewClass;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = `messenger-panel messenger-panel-${this.options.position}`;

		this.element.innerHTML = `
			<div class="messenger-panel-content">
				<div class="messenger-panel-views"></div>
				<div class="messenger-panel-nav"></div>
			</div>
		`;

		this.navigationTabs = new NavigationTabs(this.state, this.options);
		const navContainer = this.element.querySelector('.messenger-panel-nav');
		navContainer.appendChild(this.navigationTabs.render());

		this._renderCurrentView();

		this._unsubscribe = this.state.subscribe((type) => {
			if (type === 'viewChange') {
				this._renderCurrentView();
			}
		});

		return this.element;
	}

	_renderCurrentView() {
		const viewsContainer = this.element.querySelector('.messenger-panel-views');

		if (this.currentViewComponent && this.currentViewComponent.destroy) {
			this.currentViewComponent.destroy();
		}

		viewsContainer.innerHTML = '';

		const ViewClass = this.viewRegistry[this.state.currentView];
		if (ViewClass) {
			this.currentViewComponent = new ViewClass(this.state, this.options);
			viewsContainer.appendChild(this.currentViewComponent.render());
		} else {
			viewsContainer.innerHTML = `<div class="messenger-empty-state">
				<p>View not found: ${this.state.currentView}</p>
			</div>`;
		}
	}

	show() {
		if (this.element) {
			this.element.style.display = 'block';
			requestAnimationFrame(() => {
				this.element.classList.add('open');
			});
		}
	}

	hide() {
		if (this.element) {
			this.element.classList.remove('open');
			setTimeout(() => {
				if (this.element) {
					this.element.style.display = 'none';
				}
			}, 300);
		}
	}

	setHeader(headerContent) {
		const header = this.element.querySelector('.messenger-panel-header');
		if (header) {
			header.innerHTML = headerContent;
		}
	}

	destroy() {
		if (this._unsubscribe) {
			this._unsubscribe();
		}
		if (this.navigationTabs) {
			this.navigationTabs.destroy();
		}
		if (this.currentViewComponent && this.currentViewComponent.destroy) {
			this.currentViewComponent.destroy();
		}
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
